import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationStrategy, HashLocationStrategy, PathLocationStrategy} from '@angular/common';
import { AgmCoreModule } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { FileSelectDirective, FileDropDirective } from 'ng2-file-upload';
import { FileUploadModule } from 'ng2-file-upload/ng2-file-upload';
import { CKEditorModule } from 'ng2-ckeditor';
import { NgxPaginationModule } from 'ngx-pagination';

//CoreUI
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ChartsModule } from 'ng2-charts/ng2-charts';

//Routing Module
import { AppRoutingModule } from './app.routing';

// Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';
import { SimpleLayoutComponent } from './layouts/simple-layout.component';

//Guard
import { AuthGuard } from './guard/index';

//Default Component
import { AppComponent } from './app.component';

import { AgGridModule } from 'ag-grid-angular';


/* Cookie */
import { CookieService } from 'ngx-cookie-service'


//Custom Component
import { 
  LoginComponent, 
  MainComponent, 
  AlertComponent, 
  NAV_DROPDOWN_DIRECTIVES,
  SIDEBAR_TOGGLE_DIRECTIVES,  
  BreadcrumbsComponent,
  InputSelectComponent,
  DrpInputComponent,
  UserInfoCompoent,
  DataSelectorComponent,
  MatPortSelectorComponent,
  LocationSelectComponent,
  LineSelectorComponent,
  CostSelectorComponent,
  PortMultieComponent,
  MultiSelectorComponent,
  AgAutoCompleteEditor,
  AgCheckboxComponent,
  AgDeleteButtonComponent,
  AgDatePickerEditor,
  AgDropdownEditor,
  AgNumericEditor,
  DropDown,
  SalesMessageModalComponent
} from './components/index';

import {
  CnsltnListFwdr, CnsltnListItemFwdr,
  ConsultdetailComponent, EstimateListComponent, InfoMessageComponent, BookingSheetComponent, CfsSelector, TrackingComponent, CargoInformation, TrackingNewComponent, ConsultDetailUnipassFinderComponent,
  FareallComponent,
  FareRateListContainer,
  MainContainer,
  MsgMangmtList,
  FareRateDetailContainer,
  QuotationMain,
  CfsList,
  CfsInfo,
  LoadingModalContainer,
  FareRateDetailList,
  FareRateDetailSum,
  FareRateDetailRoute,
  FareRateDetailRouteItem,
  ConsultComponent,
  ConsultcheckComponent,
  FclCargoinfoComponent,
  LclCargoinfoComponent,
  LocationSelectorComponent,
  OhterCargoinfoComponent,
  FwdrMngListContainer,
  CorpSettingComponenet,
  RegionListComponent,
  CompanyUsersComponent,
  CfsEditorComponent,
  UserList, NewUserList,
  PromotionComponent,
  CountrySelectorComponent,
  BannerMngListContainer,
  BannerDetailComponent,
  AccountListComponent,
  AccountDetailComponent,
  ContractListComponent,
  ContractDetailComponent,
  CompanySelectorComponent,
  AccountSelectorComponent,
  VesselList,
  VesselDetailComponent,
  VesselMapDetailComponent,
  VesselMapUpdateListComponent,
  VesselMapList,
  PortList,
  PortMapList,
  PortDetailComponent,
  PortMapUpdateListComponent,
  PortGoogleMapComponent,
  OperatorsList,
  CorpTempComponenet,
  CorpCnsltnSettingComponent,
  OceanLineServiceRouteComponent,
  FareManagement,
  FwdrFareManagement,
  CnsltnListItemFwdrListComponent,
  CnsltnFwdrsComponent,
  StatisticsListComponent,
  BoardListComponent,
  BoardWriteComponent,
  BoardPreviewComponent,
  AdminImageUploadComponent,
  FwdrOwnerContainer,
  AnnouncedLineContainer,
  AnnouncedPortContainer,
  ScheduleByDate,
  ScheduleEdit,
  FileUploadComponent, LocationSelect2Component,UserInfoModalComponent, MailHistoryModalComponent,
  ConsultingMonitoring
} from './containers/index';

//Directieve
import {
  DatePickerDirective,
  InputEffectDirective,
  InputNumberDirective,
  InputOnlyNumbersDirective,
  InputNegaAllowedDirective,
  SelectStyleDirective,
  StoreTabsDirective,
  ClickOutsideDirective
} from './directives/index';

//Service
import {
  AlertService, 
  AuthenticationService, 
  PagerService,
  QuotationService,
  ExcelService,
  FareService,
  MessageService,
  CountryService, CityService, PortService, AirPortService, OceanLineService, AirLineService,
  CfsService,
  LoadingService,
  ConsultRequestService,
  UserService,
  ForwarderService,
  BannerService,
  PromotionService,
  CommonService,
  VesselService,
  LclPortService,
  CurrencyService,
  CostItemService,
  CodeService,
  FleetService,
  BoardService,
  UnipassService,
  ScheduleService,
  ConsultingMonitoringService,
  SalesManagerService,
  GmapLogService
} from './services/index';

import {
  ApiService
} from './services/api.service';

//Pipe
import {
  ComparePipe,
  DateBetweenPipe,
  FindInPipe,
  OrderPipe,
  SafeHtmlPipe,
  DateTime,
  ReversePipe,
  SetCommaPipe,
  CurrencyFormatPipe
} from './pipes/index'

//Library
import {BusyModule} from 'angular2-busy';
import {ToasterModule} from 'angular2-toaster';
import { DatePickerModule } from 'ng2-datepicker';
import {SelectModule} from 'ng2-select';
import { DragulaModule } from 'ng2-dragula';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MyHttpInterceptor } from './utils/http.interceptor'
import { FleetManagement } from './containers/tracking/fleet-management';
import { GeoFence } from './containers/geo-fence/geo-fence';
import { MessageModalComponent } from './containers/user/modal/message-modal';
import { MailFormComponent } from './containers/user/modal/mail-form';
import { SalesService } from './services/sales.service';
import { SalesManager } from './services/sales/model/SalesManager';
import { RegistSitemapComponent } from './containers/blog/regist-sitemap';
import { P2PScheduleUpload } from './containers/p2p-schedule-upload/p2p-schedule-upload';
import { P2PScheduleService } from './services/p2p-schedule.service';





@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    ChartsModule,
    HttpModule,
    BrowserAnimationsModule,
    BusyModule,
    ToasterModule,
    DatePickerModule,
    SelectModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyChzJhkeULPXi4ps_fZCyubd8qcUzpQ2PQ',
      libraries: ["places"],
      region: 'KR'
    }),
    AgmSnazzyInfoWindowModule,
    FileUploadModule,
    FormsModule, ReactiveFormsModule,
    DragulaModule,
    CKEditorModule,
    HttpClientModule,
    NgxPaginationModule,
    AgGridModule.withComponents([AgAutoCompleteEditor, AgCheckboxComponent, AgDatePickerEditor, AgNumericEditor, AgDeleteButtonComponent, AgDropdownEditor])
  ],
  
  exports :[ FileSelectDirective, FileDropDirective, FileUploadModule],
  
  declarations: [
    
    //directievs
    DatePickerDirective,
    InputEffectDirective,
    InputNumberDirective,
    InputOnlyNumbersDirective,
    InputNegaAllowedDirective,
    SelectStyleDirective,
    StoreTabsDirective,
    ClickOutsideDirective,

    //pipes
    ComparePipe,
    DateBetweenPipe,
    FindInPipe,
    OrderPipe,
    SafeHtmlPipe,
    DateTime,
    ReversePipe,
    SetCommaPipe,
    CurrencyFormatPipe,
    

    //Components, Container
    AppComponent,
    AlertComponent,
    FullLayoutComponent,
    SimpleLayoutComponent,
    NAV_DROPDOWN_DIRECTIVES,
    SIDEBAR_TOGGLE_DIRECTIVES,
    BreadcrumbsComponent,
    LoginComponent,
    MainComponent,
    CnsltnListFwdr, CnsltnListItemFwdr,
    ConsultdetailComponent, EstimateListComponent, InfoMessageComponent, BookingSheetComponent, CfsSelector, TrackingComponent, CargoInformation, TrackingNewComponent, ConsultDetailUnipassFinderComponent,
    FareallComponent,
    MainContainer,
    FareRateDetailContainer,
    FareRateDetailList,
    FareRateDetailSum,
    FareRateListContainer,
    MsgMangmtList,
    QuotationMain,
    FareRateDetailRoute,
    FareRateDetailRouteItem,
    InputSelectComponent,
    DrpInputComponent,
    CfsList,
    CfsInfo,
    LoadingModalContainer,
    ConsultComponent,
    ConsultcheckComponent,
    FclCargoinfoComponent,
    LclCargoinfoComponent,
    LocationSelectorComponent,
    OhterCargoinfoComponent,
    FwdrMngListContainer,
    CorpSettingComponenet,
    RegionListComponent,
    CompanyUsersComponent,
    CfsEditorComponent,
    UserInfoCompoent,
    SalesMessageModalComponent,
    UserList,
    NewUserList,
    UserInfoModalComponent,
    MessageModalComponent,
    MailFormComponent,
    MailHistoryModalComponent,
    DropDown,

    PromotionComponent,
    CountrySelectorComponent,
    BannerMngListContainer,
    BannerDetailComponent,
    AccountListComponent,
    AccountDetailComponent,
    ContractListComponent,
    ContractDetailComponent,
    CompanySelectorComponent,
    AccountSelectorComponent,
    VesselList,
    VesselDetailComponent,
    DataSelectorComponent,
    VesselMapDetailComponent,
    VesselMapUpdateListComponent,
    VesselMapList,
    PortList,
    PortMapList,
    PortDetailComponent,
    PortMapUpdateListComponent,
    PortGoogleMapComponent,
    OperatorsList,
    CorpTempComponenet,
    MatPortSelectorComponent,
    LocationSelectComponent,
    LocationSelect2Component,
    LineSelectorComponent,
    CostSelectorComponent,
    FareManagement,
    FwdrFareManagement,
    FleetManagement,
    CorpCnsltnSettingComponent,
    OceanLineServiceRouteComponent,
    PortMultieComponent,
    MultiSelectorComponent,
    AgAutoCompleteEditor, AgCheckboxComponent, AgDatePickerEditor, AgNumericEditor, AgDeleteButtonComponent, AgDropdownEditor,
    CnsltnListItemFwdrListComponent,
    CnsltnFwdrsComponent,
    StatisticsListComponent,
    BoardListComponent,
    BoardWriteComponent,
    BoardPreviewComponent,
    AdminImageUploadComponent,
    FwdrOwnerContainer,
    AnnouncedLineContainer,
    AnnouncedPortContainer,
    ScheduleEdit,
    ScheduleByDate,
    FileUploadComponent,
    GeoFence,
    ConsultingMonitoring,
    RegistSitemapComponent,
    P2PScheduleUpload
  ],
  providers: [
    ApiService,
    AuthGuard,
    AlertService,
    AuthenticationService,
    PagerService,
    QuotationService,
    ExcelService,
    FareService,
    MessageService,
    CountryService, CityService, PortService, AirPortService, OceanLineService, AirLineService,
    CfsService,
    LoadingService,
    ConsultRequestService,
    UserService,
    ForwarderService,
    BannerService,
    PromotionService,
    CommonService,
    VesselService,
    LclPortService,
    CurrencyService,
    CostItemService,
    CodeService,
    FleetService,
    BoardService,
    CookieService,
    UnipassService,
    SalesService,
    ScheduleService,
    ConsultingMonitoringService,
    SalesManagerService,
    GmapLogService,
    P2PScheduleService,
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },
    { provide: HTTP_INTERCEPTORS, useClass: 
      MyHttpInterceptor, multi: true },
    
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts